import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import {Link} from 'react-router-dom';

import {Icon} from 'front-onceforall-core';

import {USER_REQUEST_TYPES} from '../../../utils/constant';

import MessageInfo from '../../messageInfo';

import Details from './Details';
import Information from './Information';

function MandateDetailsView({details, loading, isCollectionMandate}) {
  if (loading) {
    return <div className="loading-overlay"/>;
  }

  const getDetailsTitle = () => (
    isCollectionMandate ?
      <><Translate value="mandate.details.title.collection"/> <strong>{details.subtypeName}</strong></> :
      <><Translate value="mandate.details.title.broadcast"/> <strong>{details.platform}</strong></>
  );

  return (
    <>
      <Link to={`/organisation/${isCollectionMandate ? 'collection' : 'broadcast'}-mandates`}>
        <div className="inline-container mb-4">
          <Icon
            icon="arrow-left"
            color="paragraph-light"
          />
          <Translate value="mandate.details.backToList"/>
        </div>
      </Link>

      <h2 className="mb-5">
        {getDetailsTitle()}
      </h2>
      <MessageInfo
        message={`mandate.details.editMessage.${isCollectionMandate ? 'collection' : 'broadcast'}`}
        requestType={USER_REQUEST_TYPES.MY_DOCUMENTS}
      />
      <div className="row">
        <div className="col-12 col-md-4">
          <Details
            details={details}
            isCollectionMandate={isCollectionMandate}
          />
        </div>
        <div className="col-12 col-md-8">
          <Information
            details={details}
            isCollectionMandate={isCollectionMandate}
          />
        </div>
      </div>
    </>
  );
}

MandateDetailsView.propTypes = {
  details: PropTypes.object,
  loading: PropTypes.bool.isRequired,
  isCollectionMandate: PropTypes.bool.isRequired
};

export default MandateDetailsView;
